import { ClientCustomCalendarModel } from '../../../../models';
import { getEndMonthDate } from '../../../../util';
import { getCustomCalendarPeriodEndDate } from '../../../../util/customCalendarPeriods';
import { ReportSettingAssetAmortState } from '../AssetAmort';

export const getReportEndDateAssetAmort = (
  reportSettingState: ReportSettingAssetAmortState,
  customCalendarSettings: ClientCustomCalendarModel,
): Date => {
  const { asOfAssetAmort } = reportSettingState;
  // if custom calendar client, do not get last day of month, use endDate as is
  if (customCalendarSettings.isCustomCalendarEnabled) {
    return getCustomCalendarPeriodEndDate(
      asOfAssetAmort,
      customCalendarSettings,
    );
  }

  return getEndMonthDate(asOfAssetAmort);
};
